import type { ChartChoice } from '../internalTypes'
import type { ChartDataRow } from '../types'

export const changeIsVisible = <DataKey extends string, DataRow extends ChartDataRow<DataKey>>({
  change
}: ChartChoice<DataKey, DataRow>): boolean =>
  change.change === 'internal' ||
  change.change === 'hybrid' ||
  (change.change === 'controlled' && change.display !== false)

export const changeIsLocked = <DataKey extends string, DataRow extends ChartDataRow<DataKey>>(
  choice: ChartChoice<DataKey, DataRow>
): boolean => choice.change.change === 'controlled' || choice.change.change === 'static'
